"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
var _utils = require("../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var EmptyResults = function EmptyResults(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: 1.047 * size,
    height: size,
    viewBox: "0 0 66 63",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_1025_309)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M38.759 51.879H6.219a5.296 5.296 0 01-5.291-5.3V8.603c0-2.925 2.367-5.3 5.29-5.3h37.91c2.921 0 5.292 2.372 5.292 5.3v35.548c-.003 2.925-7.74 7.728-10.661 7.728z",
    fill: (0, _utils.checkRebrand)("#09ADEA", "#055C5A")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.07 24.21V5.294A4.85 4.85 0 0047.225.44H8.63a4.85 4.85 0 00-4.847 4.855v38.661A4.85 4.85 0 008.63 48.81",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.164 16.222V5.74c0-2.925-2.368-5.3-5.291-5.3H8.963a5.296 5.296 0 00-5.291 5.3v37.976c0 2.925 2.368 5.3 5.29 5.3h19.942",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.747 49.451H8.964c-3.16 0-5.73-2.574-5.73-5.739V5.739C3.234 2.574 5.804 0 8.964 0h37.91c3.16 0 5.73 2.574 5.73 5.74v10.482h-.878V5.74c0-2.679-2.174-4.86-4.852-4.86H8.964a4.861 4.861 0 00-4.853 4.86v37.976c0 2.68 2.175 4.86 4.853 4.86h11.783v.876z",
    fill: (0, _utils.checkRebrand)("#09ADEA", "#035C5A")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.377 43.75V5.774c0-2.925 2.367-5.3 5.29-5.3H8.886a5.296 5.296 0 00-5.291 5.3V43.75c0 2.925 2.368 5.3 5.29 5.3h2.784a5.298 5.298 0 01-5.291-5.3z",
    fill: (0, _utils.checkRebrand)("#09ADEA", "#055C5A")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.07 10.006H3.784v.878h48.288v-.878z",
    fill: (0, _utils.checkRebrand)("#09ADEA", "#035C5A")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.914 7.947a2.41 2.41 0 010-4.82 2.41 2.41 0 010 4.82zm0-3.944c-.842 0-1.53.688-1.53 1.531 0 .844.688 1.532 1.53 1.532a1.531 1.531 0 000-3.063zM15.964 7.947a2.41 2.41 0 010-4.82 2.41 2.41 0 010 4.82zm0-3.944a1.531 1.531 0 000 3.063 1.531 1.531 0 000-3.063zM21.992 7.947a2.41 2.41 0 010-4.82 2.41 2.41 0 010 4.82zm0-3.944c-.842 0-1.53.688-1.53 1.531 0 .844.688 1.532 1.53 1.532a1.531 1.531 0 000-3.063z",
    fill: (0, _utils.checkRebrand)("#09ADEA", "#055C5A")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.405 5.537c0-.843.53-1.56 1.272-1.842a1.968 1.968 0 00-2.663 1.842 1.968 1.968 0 002.663 1.842 1.975 1.975 0 01-1.272-1.842zM15.456 5.537c0-.843.529-1.56 1.271-1.842a1.968 1.968 0 00-2.663 1.842 1.968 1.968 0 002.663 1.842 1.975 1.975 0 01-1.271-1.842zM21.483 5.537c0-.843.53-1.56 1.272-1.842a1.968 1.968 0 00-2.663 1.842 1.968 1.968 0 002.663 1.842 1.975 1.975 0 01-1.272-1.842z",
    fill: (0, _utils.checkRebrand)("#09ADEA", "#055C5A")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.697 51.407c9.58 0 17.346-7.78 17.346-17.376s-7.766-17.375-17.346-17.375-17.345 7.779-17.345 17.375c0 9.597 7.766 17.376 17.345 17.376z",
    fill: "#fff",
    stroke: (0, _utils.checkRebrand)("#7D74CC", "#22C488"),
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.699 51.85c-9.808 0-17.785-7.992-17.785-17.816 0-9.824 7.977-17.815 17.785-17.815 9.807 0 17.784 7.991 17.784 17.815 0 9.824-7.977 17.815-17.784 17.815zm0-34.755c-9.325 0-16.908 7.598-16.908 16.936 0 9.338 7.586 16.937 16.908 16.937 9.321 0 16.907-7.599 16.907-16.937 0-9.338-7.586-16.936-16.907-16.936z",
    fill: (0, _utils.checkRebrand)("#7D74CC", "#22C488"),
    stroke: (0, _utils.checkRebrand)("#7D74CC", "#22C488"),
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.697 21.024c7.24 0 13.108 5.88 13.108 13.13l-13.108-13.13z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.806 34.594a.438.438 0 01-.439-.44c0-6.998-5.682-12.69-12.669-12.69a.438.438 0 110-.879c7.469 0 13.546 6.088 13.546 13.57 0 .242-.196.439-.438.439zM62.12 62.854c-.719 0-1.438-.276-1.984-.823l-12.88-12.902a.438.438 0 11.62-.62l12.88 12.901a1.933 1.933 0 002.73 0 1.941 1.941 0 000-2.735L50.744 45.911a.438.438 0 11.62-.62l12.741 12.763a2.82 2.82 0 010 3.977 2.797 2.797 0 01-1.985.823z",
    fill: (0, _utils.checkRebrand)("#7D74CC", "#22C488"),
    stroke: (0, _utils.checkRebrand)("#7D74CC", "#22C488"),
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_1025_309"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.928)",
    d: "M0 0h64.145v63H0z"
  }))));
};
var _default = exports["default"] = EmptyResults;